import type { DatePicker } from '@syncfusion/ej2-calendars';

export async function s(id: string, placeholder: string, hasError: boolean) {

    await import('@syncfusion/ej2-base/styles/bootstrap4.css');
    await import('@syncfusion/ej2-buttons/styles/bootstrap4.css');
    await import('@syncfusion/ej2-inputs/styles/bootstrap4.css');
    await import('@syncfusion/ej2-popups/styles/bootstrap4.css');
    await import('@syncfusion/ej2-calendars/styles/bootstrap4.css');

    await import('./loadSyncfusion');

    const { DatePicker } = await import('@syncfusion/ej2-calendars');

    let ele1 = document.getElementById('input_' + id);
    let ele2 = document.getElementById('data_' + id);

    if (ele2.hasAttribute("data-datepicker")) {
        (ele1.parentNode as HTMLElement).classList.toggle('e-error', hasError);
        return;
    }

    ele2.setAttribute('data-datepicker', 'true');
    const ele2Val = ele2.getAttribute('value');
    let val: Date = null;
    if (ele2Val) {
        val = new Date(ele2Val);
    }
    let datepickerObject: DatePicker = new DatePicker({
        // sets the placeholder
        floatLabelType: "Never",
        placeholder: null,
        value: val,
        format: 'dd/MM/yyyy',
        change: (args: any) => {
            ele1 = document.getElementById('input_' + id);
            ele2 = document.getElementById('data_' + id);

            if (datepickerObject.value) {
                const offset = datepickerObject.value.getTimezoneOffset()
                const nextDate = new Date(datepickerObject.value.getTime() - (offset * 60 * 1000))
                ele2.setAttribute('value', nextDate.toISOString().split('T')[0]);
            }
            else {
                ele2.setAttribute('value', null);
            }
            (ele1.parentNode as HTMLElement).classList.toggle('e-error', hasError);
        },
        created: (args: any) => {
            ele1 = document.getElementById('input_' + id);

            (ele1.parentNode as HTMLElement).classList.toggle('e-error', hasError);
        }
    });

    datepickerObject.appendTo('#input_' + id);
}